import React from 'react';
import { Box, Button, Typography, Alert } from '@mui/material';
import { OtpErrorDisplayProps } from '../types';

const OtpErrorDisplay: React.FC<OtpErrorDisplayProps> = ({
  error,
  errorCode,
  onRetry,
}) => {
  const isRetryable =
    errorCode !== 'ALREADY_VIEWED' && errorCode !== 'NO_ATTEMPTS_LEFT';

  return (
    <Box>
      <Typography variant="h5" gutterBottom color="error">
        Verification Failed
      </Typography>
      <Alert severity="error" sx={{ mb: 3 }}>
        {error}
      </Alert>
      {isRetryable && (
        <Button variant="contained" color="primary" onClick={onRetry} fullWidth>
          Try Again
        </Button>
      )}
    </Box>
  );
};

export default React.memo(OtpErrorDisplay);
